<template>
    <div class="e3-video-player">
        <media-i18n :lang="language">
            <video-player :key="src" :poster="poster">
                <video-skin>
                    <video preload="none" playsinline>
                        <source :src="src" :type="type"/>
                    </video>
                    <img slot="poster" alt="" loading="eager" decoding="async"/>
                </video-skin>
            </video-player>
        </media-i18n>
    </div>
</template>

<script>
import '@videojs/html/i18n';
import '@videojs/html/video/player';
import '@videojs/html/video/skin';
import {mapGetters} from 'vuex';

export default {
    props: {
        src: String,
        type: {
            type: String,
            default: 'video/mp4'
        },
        poster: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(['language'])
    },
    watch: {
        src(src) {
            if (!src) {
                return;
            }
            this.$emit('ready');
        }
    },
    mounted() {
        this.$emit('ready');
    }
};
</script>
